import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewDepartureDockModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewReleaseFromDockActionService {
  constructor(private http: WrapperHttpService) {}

  dockDeparturePrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewDepartureDockModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Dock}${AllocationViewEndpoint.Departure}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewDepartureDockModel>(url, actionIdentifier);
  }

  dockDeparture(data: AllocationViewDepartureDockModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Dock}${AllocationViewEndpoint.Departure}`;

    return this.http.withLoading().post<void>(url, data);
  }
}
